import React, { FC } from 'react';
import { ImageSection } from 'components/energy5/structures';
import { needEmailImage } from 'assets/images/led-landing';
import useI18n from "evcharging/hooks/useI18n";

const WhyNeedEmailSection: FC = () => {
  const { t } = useI18n();

  return (
    <ImageSection
      title={t('landing.why-need')}
      text={t('landing.why-need-description')}
      imageSrc={needEmailImage}
      width={1200}
      height={676}
      showBlueBgEffect
      imageBigLg
      imageLeft
      setImageBorder
    />
  );
};

export default WhyNeedEmailSection;
